import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Wrapper } from './AolMetaIcons.style';
import React from 'react';

type Props = {
    aolVersion: number;
    hasTankersEventMismatch: boolean;
    isMrvVerified: boolean | null;
    isValid: boolean;
};

const AolMetaIconsComponent: React.FC<Props> = ({ aolVersion, hasTankersEventMismatch, isMrvVerified, isValid }) => {
    return (
        <Wrapper className="meta-icons-row">
            {aolVersion < 3 && (
                <span title="This AOL has been created with ORCA 7.">
                    <FontAwesomeIcon icon="archive" />
                </span>
            )}
            {hasTankersEventMismatch && (
                <span title="AOL and reported events mismatch">
                    <FontAwesomeIcon className="status-tankers-event-mismatch" icon="not-equal" />
                </span>
            )}
            {!isValid && (
                <span title="Invalid AOL">
                    <FontAwesomeIcon className="status-tankers-event-mismatch" icon="exclamation" />
                </span>
            )}
            {isMrvVerified && (
                <span title="Verified by DNV">
                    <FontAwesomeIcon className="status-is-mrv-verified" icon="certificate" />
                </span>
            )}
        </Wrapper>
    );
};

export default AolMetaIconsComponent;
